export const POLICY_AND_PRIVACY = 'https://kubik.app/legal/politica-de-privacidad/';
export const TERMS_AND_CONDITIONS = 'https://kubik.app/legal/terminos-de-uso/';
export const LEGAL_NOTICE_URL = 'https://kubik.app/legal/aviso-legal/';
export const LEGAL_MANIFEST_URL = 'https://kubik.app/manifiesto/';
export const SESSION_STORAGE_ACCESS_TOKEN = 'kubik-session';
